// extracted by mini-css-extract-plugin
module.exports = {"icon":"Spinner_icon__1sq6W","spin":"Spinner_spin__exvrK","opacity":"Spinner_opacity__2py_T"};